import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { omitBy } from 'lodash-es';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { IUserSessionHistorical, IUserSessionLive } from './models/user-session.model';

@Injectable({ providedIn: 'root' })
export class ReportingUserSessionsApiClient {
  public constructor(private readonly httpService: BaseHttpService) {}

  public getUserSessionsHistorical(
    userId: string,
    tenantId: string,
    take: number = 10,
    skip: number = 0,
    search?: string,
  ): Observable<IUserSessionHistorical[]> {
    return this.httpService.get(
      `facade/v1/portal/users/${userId}/historical-user-sessions`,
      omitBy({ take, skip, tenantId, search }, (x) => !x),
    );
  }

  public getUserSessionsLive(userId: string): Observable<IUserSessionLive[]> {
    return this.httpService.get(`live-data/v1/user-sessions/${userId}`);
  }
}
